import { useEffect, useRef, useMemo } from "react";
import useAZZKUVoivodeships from "hooks/AZZKU/useAZZKUVoivodeships";
import useAZZKUAvailableTerritories from "hooks/AZZKU/useAZZKUAvailableTerritories";

import Loader from "components/Loader";
import CheckboxGroup from "components/CheckboxGroup";
import Options from "components/Options";

export default function Step3({ params, errors, onChange }) {

   const { d: voivodeships } = useAZZKUVoivodeships();
   const { d: available_territories } = useAZZKUAvailableTerritories( params.variable_id );
   const only_country = available_territories?.length === 1 && available_territories?.[0] === "country";

   useEffect(() => {
      if ( !available_territories || available_territories.length === 2 ) return;
      if ( available_territories[0] === "country" ) { 
         onChange({ 
            territorial_scale: available_territories[0] === "country" ? 1 : 2,
            voivodeship_ids: [0] 
         });
      }
   }, [ available_territories ])

   return voivodeships && available_territories ? (
      <>
         <Options
            name="territorial_scale"
            value={ params.territorial_scale }
            disabled={ available_territories.length === 1 }
            extra_classes={ available_territories.length === 1 ? "disabled" : "" }
            options={[
               { value: 1, label: "Polska" },
               { value: 2, label: "Województwa" }
            ]}
            onChange={( n, v ) => onChange({
               [n]: v,
               voivodeship_ids: +v === 1 ? [0] : []
            })}
         />

         { only_country &&
            <div> Wyniki występują jedynie w skali krajowej </div>
         }

         { +params.territorial_scale === 2 &&
            <>
               <p> Wybierz 1 województwo: </p>

               <CheckboxGroup
                  max={1}
                  name="voivodeship_ids"
                  value={ params.voivodeship_ids || []}
                  buttons={ voivodeships }
                  onChange={ onChange }
               />
            </>
         }

         { errors.voivodeship_ids && <div className="error"> { errors.voivodeship_ids } </div>}
      </>
   ) : <Loader />
}